<script lang="ts">
  import {Tooltip} from 'flowbite-svelte';
  import {cn} from 'Catalyst/cn';
  import {tooltipSlotsBaseOffset} from 'Catalyst/tokens/output/tooltip';
  import type {TooltipProps} from '.';
  import {DEFAULT_ARROW_SIZE, ONE_REM_IN_PX, tooltipTvProps} from '.';

  // eslint-disable-next-line no-unused-vars
  type $$Props = TooltipProps;

  export let label: $$Props['label'] = 'Label';
  export let placement: $$Props['placement'] = 'bottom';

  const tooltipTvSlots = tooltipTvProps();

  const klass = $$restProps.class;
</script>

<Tooltip
  {...$$restProps}
  class={cn(tooltipTvSlots.base(), klass)}
  offset={parseFloat(tooltipSlotsBaseOffset) * ONE_REM_IN_PX +
    DEFAULT_ARROW_SIZE}
  {placement}
  shadow={false}
>
  {#if $$slots.default}
    <slot />
  {:else}
    <div class={tooltipTvSlots.label()}>
      {label}
    </div>
  {/if}
</Tooltip>
